import React from 'react';

const CatalogHeader = ({ groups, currentGroupId, onClick }) => {
    const visibleGroups = (groups || []).filter((g) => g && g.id);

    return (
        <div className='catalog-category-bar-wrap'>
            <div className='catalog-category-bar' id='group-header'>
                {visibleGroups.map((g) => (
                    <button
                        type='button'
                        id={`group-${g.id}`}
                        key={g.id}
                        className={
                            'catalog-category-pill' +
                            (Number(currentGroupId) === Number(g.id) ? ' catalog-category-pill--active' : '')
                        }
                        onClick={() => onClick(g.id)}
                    >
                        {g.name}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CatalogHeader;
